import { render, staticRenderFns } from "./ClientDetailModal.vue?vue&type=template&id=0e8aa8f4&scoped=true&"
import script from "./ClientDetailModal.vue?vue&type=script&lang=js&"
export * from "./ClientDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetailModal.vue?vue&type=style&index=0&id=0e8aa8f4&prod&scoped=true&lang=css&"
import style1 from "./ClientDetailModal.vue?vue&type=style&index=1&id=0e8aa8f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8aa8f4",
  null
  
)

export default component.exports